module.exports = __webpack_public_path__ + "cc1e8e49a72884b59beec4114a385640.png";